import React, { Component } from "react";
import { connect } from "react-redux";
import {
  calucate,
  addToelagen,
  addInhoudingen,
} from "../redux/actions/formActions";
import { withRouter } from "react-router-dom";
import {
  showMiscModal,
  showLoader,
  hideLoader,
} from "../redux/actions/miscActions";
import { Input, Select, Divider } from "antd";
import GradProcesBar from "./utils/GradProcesBar";

const { Option } = Select;

export class TaxTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectAfterValue: "bruto",
      bedrag: "",
      toelagen: [],
      inhoudingen: [],
    };
  }

  componentDidMount = () => {};

  handleAfterValueSelect = (value) => {
    this.setState({
      selectAfterValue: value,
    });
  };

  handleCalulate = () => {
    this.props.showLoader();
    const { taxCalcData, toelagen, inhoudingen } = this.props.formData;
    const { bedrag, selectAfterValue } = this.state;
    this.props.calucate(
      taxCalcData,
      toelagen,
      inhoudingen,
      bedrag,
      selectAfterValue,
      this.props.history
    );
  };

  handleRemove = (index) => {
    const { toelagen } = this.props.formData;
    toelagen.splice(index, 1);
    this.props.addToelagen(toelagen);
  };

  handleRemoveInhoudingen = (index) => {
    const { inhoudingen } = this.props.formData;
    inhoudingen.splice(index, 1);
    this.props.addInhoudingen(inhoudingen);
  };

  showForm(content) {
    this.props.showMiscModal("", content);
  }

  handleInput = (e) => {
    if (e.target.value.match(/^[0-9]+([0-9.]{1,3})?$/gm)) {
      this.setState({
        bedrag: e.target.value,
      });
    }
  };

  componentWillUnmount = () => {
    this.props.hideLoader();
  };

  render() {
    const { selectAfterValue, bedrag } = this.state;
    const { toelagen, inhoudingen } = this.props.formData;
    const { isLoaderVisibile } = this.props.misc;
    const selectAfter = (
      <Select value={selectAfterValue} onChange={this.handleAfterValueSelect}>
        <Option value="bruto">Bruto</Option>
        <Option value="netto">Netto</Option>
      </Select>
    );

    return (
      <div className="tax-table">
        <div className="input-container">
          <Input
            addonBefore={<i className="fas fa-dollar-sign"></i>}
            addonAfter={selectAfter}
            name="bedrag"
            onChange={this.handleInput}
            value={bedrag}
            size="large"
          />
          {/* <p>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Natus
            laudantium commodi iusto corrupti soluta, odit blanditiis? Dicta at
            libero, aspernatur eveniet corporis in quia optio, nisi enim ad
            cupiditate hic.
          </p> */}
          {isLoaderVisibile ? <GradProcesBar /> : ""}
          <button className="large-btn" onClick={this.handleCalulate}>
            CALCULATE
          </button>
        </div>
        <div className="data-input">
          <div className="toelagen">
            <h3>Toelagen</h3>
            <div className="list">
              {toelagen
                .filter((x) => x.label !== "blanco")
                .map((x, index) => {
                  return (
                    <div
                      className="toelagen-list"
                      key={x.label.concat(x.bedrag)}
                    >
                      <p>{x.label}</p>
                      <p>
                        {x.isBedrag
                          ? new Intl.NumberFormat("IN", {
                              style: "currency",
                              currency: "SRD",
                            }).format(`${x.bedrag}`)
                          : x.bedrag}
                        {/* {x.bedrag}{" "} */}
                        {!x.isBedrag ? (
                          <i className="fas fa-percentage"></i>
                        ) : (
                          ""
                        )}
                      </p>
                      <p>{x.belastbaar ? "belastbaar" : "niet belastbaar"}</p>
                      <span
                        className="remove-item"
                        onClick={() => this.handleRemove(index)}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  );
                })}
            </div>
            <button
              className="link-button"
              onClick={() => this.showForm("toelagen")}
            >
              Toelagen toevoegen
            </button>
          </div>
          <Divider />
          <div className="inhoudingen">
            <h3>Inhoudingen</h3>
            <div className="list">
              {inhoudingen
                .filter((x) => x.label !== "blanco")
                .map((x, index) => {
                  return (
                    <div
                      className="toelagen-list"
                      key={x.label.concat(x.bedrag)}
                    >
                      <p>{x.label}</p>
                      <p>
                        {x.isBedrag
                          ? new Intl.NumberFormat("IN", {
                              style: "currency",
                              currency: "SRD",
                            }).format(`${x.bedrag}`)
                          : x.bedrag}
                        {!x.isBedrag ? (
                          <i className="fas fa-percentage"></i>
                        ) : (
                          ""
                        )}
                      </p>
                      <p>{x.belastbaar ? "belastbaar" : "niet belastbaar"}</p>
                      <span
                        className="remove-item"
                        onClick={() => this.handleRemoveInhoudingen(index)}
                      >
                        <i className="fas fa-times-circle"></i>
                      </span>
                    </div>
                  );
                })}
            </div>

            <button
              className="link-button"
              onClick={() => this.showForm("inhoudingen")}
            >
              Inhouding toevoegen
            </button>
          </div>
        </div>
        <div className="mobile-only">
          {isLoaderVisibile ? <GradProcesBar /> : ""}
          <button className="large-btn" onClick={this.handleCalulate}>
            CALCULATE
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
  misc: state.misc,
});

export default connect(mapStateToProps, {
  calucate,
  addToelagen,
  addInhoudingen,
  showMiscModal,
  showLoader,
  hideLoader,
})(withRouter(TaxTable));
